var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "445px",
    height: "572px",
    viewBox: "0 0 445 572",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-237.000000, -157.000000)",
    fill: "#382DFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(237.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.490785,116.898223 C313.229462,48.894327 248.763499,0 172.877654,0 C77.3999622,0 0,77.3999622 0,172.877654 C0,268.355346 77.3999622,345.755308 172.877654,345.755308 C181.556563,345.755308 190.0861,345.115769 198.421709,343.881247 L198.421709,116.898223 L336.490785,116.898223 Z",
    id: "Combined-Shape",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.849534,330.984259 C42.261267,304.108883 0,243.428593 0,172.877654 C0,77.3999622 77.3999622,0 172.877654,0 C268.355346,0 345.755308,77.3999622 345.755308,172.877654 C345.755308,178.414814 345.494986,183.891172 344.985913,189.295158 C323.579128,179.799666 299.884547,174.524108 274.957793,174.524108 C185.017261,174.524108 111.11845,243.206883 102.849534,330.984259 Z",
    id: "Combined-Shape",
    fillOpacity: 0.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(271.313259, 398.826087) scale(-1, -1) translate(-271.313259, -398.826087) translate(98.313259, 225.826087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.849534,330.984259 C42.261267,304.108883 0,243.428593 0,172.877654 C0,77.3999622 77.3999622,0 172.877654,0 C268.355346,0 345.755308,77.3999622 345.755308,172.877654 C345.755308,178.414814 345.494986,183.891172 344.985913,189.295158 C323.579128,179.799666 299.884547,174.524108 274.957793,174.524108 C185.017261,174.524108 111.11845,243.206883 102.849534,330.984259 Z",
    id: "Combined-Shape",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.490785,116.898223 C313.229462,48.894327 248.763499,0 172.877654,0 C77.3999622,0 0,77.3999622 0,172.877654 C0,268.355346 77.3999622,345.755308 172.877654,345.755308 C181.556563,345.755308 190.0861,345.115769 198.421709,343.881247 L198.421709,116.898223 L336.490785,116.898223 Z",
    id: "Combined-Shape",
    fillOpacity: 0.44
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a4b712c75d3b078120f66cab10bf440.svg";
export { ForwardRef as ReactComponent };